import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import Checkbox from "../../../FormElement/Checkbox";

import "./styles.scss";

interface LocationSelectModalProps {
  allLocations: { id: number; name: string }[];
  selectedLocations: { id: number; name: string }[];
  setSelectedLocations: (locations: { id: number; name: string }[]) => void;
  onClose: () => void;
}

export const LocationSelectModal: React.FC<LocationSelectModalProps> = ({
  allLocations,
  selectedLocations,
  setSelectedLocations,
  onClose,
}) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`hookForm.locationSelect.modal.${key}`);

  const [temporarySelectedLocations, setTemporarySelectedLocations] =
    useState<{ id: number; name: string }[]>(selectedLocations);

  const handleCheck = (id: number) => {
    setTemporarySelectedLocations((prev) => {
      if (prev.some((l) => l.id === id)) {
        return prev.filter((l) => l.id !== id);
      }
      return [
        ...prev,
        { id, name: allLocations.find((l) => l.id === id)?.name || "" },
      ];
    });
  };

  const handleSubmit = () => {
    setSelectedLocations(temporarySelectedLocations);
    onClose();
  };

  return (
    <div className="modal modal-default admin-location-select-modal">
      <div className="modal-mains">
        <button type="button" className="btn-close" onClick={onClose}></button>
        <div className="top-title">{t("title")}</div>
        <div className="admin-location-select-modal-list">
          {allLocations.map((location) => (
            <div key={location.id} className="admin-location-select-modal-item">
              <Checkbox
                id={location.id.toString()}
                checked={temporarySelectedLocations.some(
                  (l) => l.id === location.id
                )}
                onChange={() => handleCheck(location.id)}
                label={location.name}
              />
            </div>
          ))}
        </div>
        <div className="admin-location-select-modal-buttons">
          <button type="button" className="btn btn-border" onClick={onClose}>
            {t("cancel")}
          </button>
          <button type="button" className="btn btn-blue" onClick={handleSubmit}>
            {t("submit")}
          </button>
        </div>
      </div>
    </div>
  );
};
